import { useMutation } from '@gogame/query';

import { batchShareCreatives } from 'scenes/Gallery/GalleryPage/Creatives/sources/creatives';

import { share } from '../queryKeyFactory';

export const useBatchShare = () => {
  const mutation = useMutation(share(), batchShareCreatives, {
    successMessage: () => {
      return `Creatives successfully shared`;
    },
  });

  return [mutation.mutateAsync, mutation];
};
